import type { Period } from "./types";

export const OBSERVABILITY_SCHEMA_QUERY = `
  query ObservabilityContractCheck {
    __type(name: "RootQueryType") {
      fields {
        name
      }
    }
  }
`;

export const OBSERVABILITY_QUERY = `
  query ObservabilityEvents($organizationId: ID!, $since: DateTime) {
    observabilityEvents(organizationId: $organizationId, since: $since, limit: 500) {
      id
      traceId
      organizationId
      userId
      service
      surface
      action
      runId
      status
      inputTokens
      outputTokens
      costUsd
      latencyMs
      metadata
      error
      occurredAt
    }
  }
`;

export function sinceForPeriod(period: Period): string {
  const days = period === "24h" ? 1 : period === "7d" ? 7 : period === "30d" ? 30 : 90;
  return new Date(Date.now() - days * 24 * 60 * 60 * 1000).toISOString();
}
